import en from './en-US';
import ru from './ru-RU';

export default {
  ...en,
  ...ru,
};